<!-- 企业级-业务领域-仓储业务-产品管理 -->
<template>
  <div class="mainArea COutInWareManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-tabs v-model="tabActive" @tab-click="tabChange" class="tabList" stretch>
          <el-tab-pane label="入库管理" name="1">
            <CInware v-if="tabActive == '1'"></CInware>
          </el-tab-pane>
          <el-tab-pane label="出库管理" name="2">
            <COutware v-if="tabActive == '2'"></COutware>
          </el-tab-pane>
          <!-- <el-tab-pane label="仓储订单管理" name="3">
            <CWareOrder v-if="tabActive == '3'"></CWareOrder>
          </el-tab-pane> -->
        </el-tabs>
      </div>

      
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import CInware from "./CInware.vue"
  import COutware from "./COutware.vue"
  import CWareOrder from "./CWareOrder.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"

  export default {
    name: 'COutInWareManage',
    components: {
      CBreadCrumb,
      CInware,
      COutware,
      CWareOrder
    },
    data() {
      return {
        tabActive:'1',
      };
    },
    mounted(){

    },
    created: async function () {
      var type = this.$route.query.type
      if(type == 'in'){
        this.tabActive = '1'
      }else if(type == 'out'){
        this.tabActive = '2'
      }
    },
    methods: {
      //tabs切换
      tabChange(tab, event) {
        console.log(tab, event);
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.COutInWareManage{
  .mainBodyContent{
    padding: 0;
  }
  .tabList{
    width: 100%;
    // tabs标签
    .el-tabs__header {
      width: 100%;
      margin-bottom: 0;
      box-sizing: border-box;
      border-bottom: 1px solid #E4E7ED;
      .el-tabs__nav-wrap {
        padding-left: 20px;
        width: 360px;
      }
      .el-tabs__item {
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/COutInWareManage/COutInWareManage.vue